import React, { Component } from 'react';

import Tooltip from 'material-ui/Tooltip';

import * as Utils from '../../../lib/designerUtils';
import * as DesignerState from '../../../state/reducer/designer/designer';
import SegmentService, {
    EVENTS as SEGMENT_EVENTS
} from '../../../lib/segment/SegmentService';
import Console from '../../../lib/debug';

export default class Palette extends Component {
    addNotes() {
        let dispatch = this.props.dispatch;
        let session = this.props.session;

        DesignerState.addNotes(dispatch, session);
    }

    callback() {
        let dispatch = this.props.dispatch;
        let session = this.props.session;

        DesignerState.createBlock(
            dispatch,
            session,
            Utils.BlockTypes.STRENGTH_POWER
        );

        SegmentService.track(SEGMENT_EVENTS['ClickCTA'].key, {
            sources: 'Web app',
            ctaLocation: 'Session builder',
            ctaText: 'Add Block'
        });
    }

    render() {
        Console.render('designer.Palette');
        let exerciseToolTip =
            'Blocks are the building blocks of your session.' +
            'They contain exercises, circuits and supersets.';

        let paletteClasses =
            'designer-palette layout-row layout-align-space-between-center';
        let palette = (
            <div>
                <div className={paletteClasses}>
                    <div
                        className="palette-button inverse"
                        onClick={() => this.callback()}
                    >
                        <span>Add Block</span>
                        <Tooltip title={exerciseToolTip}>
                            <i className="mdi mdi-information info-icon" />
                        </Tooltip>
                    </div>
                </div>
                <div className={paletteClasses}>
                    <div className="palette-button-divider" />
                </div>
            </div>
        );
        return palette;
    }
}
